var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeedometer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.112,
    height: 64.384,
    viewBox: "0 0 107.112 64.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "speedometer",
    d: "M91.426,117.808A53.556,53.556,0,0,0,0,155.678v3.138H26.884v-3.138a26.668,26.668,0,0,1,37.24-24.487l-7.779,13.177a11.237,11.237,0,1,0,5.4,3.191l7.8-13.212a26.647,26.647,0,0,1,10.679,21.332v3.138h26.884v-3.138a53.206,53.206,0,0,0-15.686-37.87ZM57.835,157.789a4.969,4.969,0,1,1,.533-3.765,4.974,4.974,0,0,1-.533,3.765Zm28.522-5.25a32.95,32.95,0,0,0-65.6,0H6.379a46.928,46.928,0,0,1,4.759-17.728l5.682,3.28,3.138-5.435-5.674-3.276a47.668,47.668,0,0,1,12.974-12.975l3.262,5.65,5.435-3.138-3.267-5.659A46.926,46.926,0,0,1,50.418,108.5v6.9h6.276v-6.9a46.927,46.927,0,0,1,17.729,4.755l-3.267,5.659,5.435,3.138,3.262-5.65a47.671,47.671,0,0,1,12.974,12.975l-5.674,3.276,3.138,5.435,5.682-3.28a46.928,46.928,0,0,1,4.759,17.728H86.356Z",
    transform: "translate(0 -102.122)",
    fill: "#09eab4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer);
export default __webpack_public_path__ + "static/media/speedometer.ed05ac9a961eea2aad48f0bd42c8e164.svg";
export { ForwardRef as ReactComponent };